import { createContext } from 'react';
import { Company } from '../../companies/company.model';

export type SubdomainType = {
    company: Company;
    refreshCompany: () => Promise<void>;
}

export const SubdomainContext = createContext<SubdomainType>(null);